import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuList from '@mui/material/MenuList';
import Popper from '@mui/material/Popper';
import PropTypes from 'prop-types';
import { StyledMenu, StyledMenuItem } from './PopperMenu.styles.js';
const _excluded = ["anchorEl", "open", "placement", "onClose", "itemList", "paperStyle", "maxHeight"];
function PopperMenu(_ref) {
  let {
      anchorEl,
      open,
      placement,
      onClose,
      itemList,
      paperStyle,
      maxHeight
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const handleClose = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    onClose();
  };
  const handleListKeyDown = event => {
    if (event.key === 'Escape') {
      onClose();
    }
  };
  return /*#__PURE__*/React__default.createElement(Popper, _extends({}, otherProps, {
    open: open,
    anchorEl: anchorEl,
    placement: placement,
    transition: true,
    sx: {
      zIndex: 1500
    }
  }), _ref2 => {
    let {
      TransitionProps,
      placementPosition
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: placementPosition === 'bottom-start' ? 'left top' : 'left bottom'
      }
    }), /*#__PURE__*/React__default.createElement(StyledMenu, {
      paperStyle: paperStyle,
      maxHeight: maxHeight
    }, /*#__PURE__*/React__default.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/React__default.createElement(MenuList, {
      autoFocusItem: open,
      id: "composition-menu",
      "aria-labelledby": "composition-button",
      onKeyDown: handleListKeyDown
    }, itemList.map((item, index) => /*#__PURE__*/React__default.createElement(StyledMenuItem, {
      onClick: e => {
        item.func(e);
        onClose();
      }
      // eslint-disable-next-line react/no-array-index-key
      ,

      key: index
    }, item.children))))));
  });
}
PopperMenu.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element)]),
  placement: PropTypes.string,
  onClose: PropTypes.func,
  itemList: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  paperStyle: PropTypes.shape({}),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
PopperMenu.defaultProps = {
  open: false,
  anchorEl: null,
  placement: 'bottom-start',
  onClose: () => {},
  itemList: [],
  paperStyle: {},
  maxHeight: 200
};
export { PopperMenu as default };